import React from 'react';

function TabAdd({ id, active, onClick }) {
  return (
    <div id="add-new" className="chrome-tab--new">
      <i className="icofont-plus"></i>
    </div>
  );
}

export default TabAdd;
